<template>
    <CardSelect :app="app" :card="card" :actionable="false">

        <template #title>
            Select how to generate your texture.
        </template>

        <template #options>
            <OptionIcon 
                v-for="option in activeOptions" 
                :id="option.id" 
                :index="option.index"
                :icon="option.icon" 
                :label="option.label" 
                :description="option.description" 
                :selected="selected === option.id" 
                @click="handleOption(option)" 
                @mouseenter="handleHover(option)"
                @mouseleave="handleHover(null)">
            </OptionIcon>
        </template>

        <template #post>
            <AtomText  class="hide-on-mobile" :text="guidance" />
        </template>

    </CardSelect>
</template>

<script>
import CATEGORY from '@generio-ai/library-legacy/constants/category'
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import CARD from '@/constants/card.js'
import OPTION from '@/constants/option.js'
import AtomText from '@/components/common/atom/AtomText.vue'
import CardSelect from '@/components/flow/cards/CardSelect.vue'
import OptionIcon from '@/components/flow/options/OptionIcon.vue'

export default {
    name: 'CardSelectTexture',
    components: {
        CardSelect,
        OptionIcon,
        AtomText
    },
    props: {
        app: {
            type: String,
            required: true
        },
        card: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            hovered: null
        }
    },
    computed: {
        ...mapGetters('flows', [
            'isActiveByIndex',
            'isLastByIndex',
            'getCardByCategories'
        ]),

        isActiveCard() {
			return this.isActiveByIndex(this.app, this.index)
		},
        isLastCard() {
            return this.isLastByIndex(this.app, this.index)
        },

        hasTexturingGenerate() {
            return this.cardsTexturing !== null
        },

        index() {
            return this.card.index
        },
        selected() {
            return this.card.option
        },
        prompt() {
            return this.card.prompt
        },

        options() {
            return [
                {
                    index: 1,
                    active: this.hasTexturingGenerate,
                    ...OPTION.SELECT_TEXTURE_GENERATE,
                },
                {
                    index: 2,
                    active: true,
                    ...OPTION.SELECT_TEXTURE_PROMPT,
                },
                {
                    index: 3,
                    active: true,
                    ...OPTION.SELECT_TEXTURE_IMAGE,
                },
                
            ]
        },
        activeOptions() {
            return this.options.filter(option => option.active)
        },
        guidance() {
            switch (this.hovered) {
                case OPTION.SELECT_TEXTURE_GENERATE.id: 
                    return OPTION.SELECT_TEXTURE_GENERATE.guidance
                case OPTION.SELECT_TEXTURE_PROMPT.id:
                    return OPTION.SELECT_TEXTURE_PROMPT.guidance
                case OPTION.SELECT_TEXTURE_IMAGE.id:
                    return OPTION.SELECT_TEXTURE_IMAGE.guidance
            }
            return ''
        },

        index() {
            return this.card.index
        },
        category() {
            return this.card.category
        },
        prompt() {
            return this.card.prompt
        },
        promptUser() {
			return this.prompt?.user
		},
        promptQuality() {
            return this.prompt?.quality
        },
        promptSolid() {
            return this.prompt?.solid
        },

        cardsTexturing() {
            return this.getCardByCategories(this.app, this.card, [ CATEGORY.PHOTO, CATEGORY.PREVIEW ])
        }
    },
    methods: {
        ...mapActions('flows', [
            'newTransaction',
            'commitPrimitiveAsset',
            'fetchBase'
        ]),
        handleHover(option) {
            this.hovered = option?.id
        },
        handleOption(option) 
        {
            // update card
            this.card.option = option.id

            switch(option.id) 
            {
                case OPTION.SELECT_TEXTURE_GENERATE.id:
					this.newTransaction({
                        app: this.app,
						card: this.card,
						taskCommit: this.commitPrimitiveAsset(),
                        taskFetch: this.fetchBase({
							component: CARD.GENERATE_TEXTURE,
							category: this.category
						})
					})
					break

                case OPTION.SELECT_TEXTURE_PROMPT.id:
                    this.newTransaction({
                        app: this.app,
                        card: this.card,
                        taskCommit: this.commitPrimitiveAsset(),
                        taskFetch: this.fetchBase({
							component: CARD.PROMPT,
							category: this.category
						})
                    })
                    break

                case OPTION.SELECT_TEXTURE_IMAGE.id:
                    this.newTransaction({
                        app: this.app,
                        card: this.card,
                        taskCommit: this.commitPrimitiveAsset(),
                        taskFetch: this.fetchBase({
                            component: CARD.IMPORT,
                            category: CATEGORY.PHOTO
                        })
                    })
                    break
            }
        },
        handleKeyboardShortcuts(event) 
        {
            // only if the card is active
            if (!this.isActiveCard) return

            // Get the pressed key
            const key = event.key

            // Check if the key is a single digit (1-9)
            if (/^[1-9]$/.test(key)) {

                // Convert to 0-indexed position
                const index = parseInt(key, 10) - 1

                // If an option exists at that index, trigger it
                if (index >= 0 && index < this.options.length) {

                    event.preventDefault()
                    this.handleOption(this.options[index])
                }
            }
        }
    },
    mounted() {
		window.addEventListener('keydown', this.handleKeyboardShortcuts)
	},
	beforeUnmount() {
        window.removeEventListener('keydown', this.handleKeyboardShortcuts)
    }
}
</script>